import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { DashboardService } from '../dashboard.service';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from 'app/shared/language.service';
import { AuthService } from 'app/auth/auth.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

export interface DialogData {
  visitid: number;
  // remark: string;
  //name: string;
}

@Component({
  selector: 'app-WaitingReason',
  templateUrl: './WaitingReason.component.html',
  styleUrls: ['./WaitingReason.component.scss']
})
export class WaitingReasonComponent implements OnInit {
  WaitingReason;
  destroywaiting$: Subject<boolean> = new Subject<boolean>();
  constructor(private dialog: MatDialog,
    private dashboardService: DashboardService, private authService: AuthService, private translate: TranslateService,
    private langservice: LanguageService,
    @Inject(MAT_DIALOG_DATA) private data: DialogData,
  ) {
    translate.addLangs(['en', 'fr', 'hi']);
    if (this.langservice.setlang) {
      translate.setDefaultLang(this.langservice.setlang);
    }
    else {
      translate.setDefaultLang('en');
    }
  }

  ngOnInit() {
  }
  ngOnDestroy() {
    this.destroywaiting$.next(true);
    this.destroywaiting$.unsubscribe();
    this.WaitingReason=null;
    
  }
  closedialog() {
    this.dialog.closeAll();
  }
  savereason() {
    this.dashboardService.open_loader_Dialog();
    this.dashboardService.save_waiting_reason(this.data.visitid, this.WaitingReason).pipe(takeUntil(this.destroywaiting$)).subscribe(
      data => this.successreason(data), err => this.failedreason(err)
    )

  }

  successreason(data) {
    this.dashboardService.waitingreason = true;
    this.dialog.closeAll();
    this.dashboardService.openSnackBar(this.authService.validationMsg['dashboardValidMsg.msg5'], this.authService.validationMsg['Ok']);
  }
  failedreason(err) {
    this.dashboardService.waitingreason = false;
    this.dialog.closeAll();
    if (err.status == 403) {
      this.dashboardService.openSnackBar("You Don't have Permission", "OK");
    } else {
      this.dashboardService.openSnackBar(this.authService.validationMsg['dashboardValidMsg.msg6'], this.authService.validationMsg['Ok']);
    }

  }
}
